// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3-_WJ","item":"PaymentsMobile_item__2mEJs","label":"PaymentsMobile_label__3gpUj","amount":"PaymentsMobile_amount__3xri0"};